import { useUpdateEffect } from 'react-use';

import { useGetPasswordExpirationSettingsQuery } from '@dreryk/egabinet-security-frontend';
import { FormContextValues, useFormController } from '@dreryk/react-common';

import { personnelTranslationKeys } from '../../translations';

import { DoNotEnforcePasswordChangeField } from './DoNotEnforcePasswordChangeField';
import { StyledPasswordExpirationSettingsForm } from './PasswordExpirationSettings.styled';
import { PasswordExpirationSettingsFormBean } from './PasswordExpirationSettings.types';
import { PasswordSettingsLoader } from './PasswordSettingsLoader';

export type PasswordExpirationSettingsController = FormContextValues<PasswordExpirationSettingsFormBean>;

const PasswordExpirationSettings = (): JSX.Element => {
   const { register, formState, setValue, watch } = useFormController<PasswordExpirationSettingsFormBean>({
      doNotEnforcePasswordChange: null,
   });
   const {
      data: passwordExpirationSettings,
      loading: passwordExpirationSettingsLoading,
   } = useGetPasswordExpirationSettingsQuery();

   useUpdateEffect(() => {
      setValue(
         DoNotEnforcePasswordChangeField.fieldName,
         Boolean(passwordExpirationSettings?.doNotEnforcePasswordChange)
      );
   }, [passwordExpirationSettings?.doNotEnforcePasswordChange]);

   return (
      <StyledPasswordExpirationSettingsForm noValidate>
         {passwordExpirationSettingsLoading && !formState.isDirty ? (
            <PasswordSettingsLoader text={personnelTranslationKeys.myAccount.password.loadingPasswordSettings} />
         ) : (
            <DoNotEnforcePasswordChangeField
               register={register}
               isDirty={formState.isDirty}
               value={watch('doNotEnforcePasswordChange')}
            />
         )}
      </StyledPasswordExpirationSettingsForm>
   );
};

export { PasswordExpirationSettings };
